/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three'
import React, { useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';

import { setWallCloseStateWrap } from '../../../../../../../../action';
import { const_var, params } from '../../../../../../../../redux/reducers/reducer';

import { CSG } from '../../../../../../../../assets/libs/csg-lib';
import { delModel, extrudeSettings, wainscotTrimModel } from '../../../../../../../../utils/Functions';
import { MaterialTrim, MaterialWainScotTrimNew } from '../../../../../../CustomMaterial';

const TrimModel = () => {
    const dispatch = useDispatch();

    const cBBackWallCloseState = useSelector((state) => state.reducer.backWallCloseState)

    const [rightWallCloseSize, setRightWallCloseSize] = useState(0);
    const [leftWallCloseSize, setLeftWallCloseSize] = useState(0);

    const wallThickness = 0.005;
    const Temp_B_p_w = params.leanB_p_w - 0.3;

    const legDistance = useMemo(() => {
        return (const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined) ? const_var.DistanceArr[params.p_b_t][params.p_r_s] : 5
    }, [const_var.DistanceArr, params.p_b_t, params.p_r_s,const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined])

    const frontOffset = useMemo(() => {
        if (params.backLeanStoragePosition === params.leanB_p_d - parseInt(params.add_storage_back)) {
            return -0.15;
        } else if (params.backLeanStoragePosition === 0) {
            return 0.3;
        } else {
            return 0;
        }
    }, [params.leanB_p_d, legDistance, params.backLeanStoragePosition, params.add_storage_back]);

    const backOffset = useMemo(() => {
        if (params.backLeanStoragePosition === 0) {
            return 0.3;
        } else {
            return 0;
        }
    })

    const sidewallOffset = 0.15;
    
    const frontLeftVrTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        if(params.p_b_c_b_b_l !== 'Close'){
            if(params.p_b_c_b_b_l === 'Open'){
                model.moveTo(Temp_B_p_w / 2 + 0, 0);
                model.lineTo(Temp_B_p_w / 2 + 0, params.leanB_p_h - (params.b_l_t_r_pB / 12 * 0.1));
                model.lineTo(Temp_B_p_w / 2 + 0.23, params.leanB_p_h - (params.b_l_t_r_pB / 12 * 0.1));
                model.lineTo(Temp_B_p_w / 2 + 0.23, 0);
                model.closePath();
            } else {
                model.moveTo(Temp_B_p_w / 2 + 0, leftWallCloseSize + 0.1);
                model.lineTo(Temp_B_p_w / 2 + 0, 0);
                model.lineTo(Temp_B_p_w / 2 + 0.23, 0);
                model.lineTo(Temp_B_p_w / 2 + 0.23, leftWallCloseSize + 0.1);
                model.closePath();
            }
        }

        return model;
    }, [params.leanB_p_h, Temp_B_p_w, leftWallCloseSize, params.p_b_c_b_b_l, params.b_l_t_r_pB])
    
    const frontRightVrTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        if(params.p_b_c_b_b_r !== 'Close'){
            if(params.p_b_c_b_b_r === 'Open'){
                model.moveTo(-(Temp_B_p_w / 2 + 0.235), 0);
                model.lineTo(-(Temp_B_p_w / 2 + 0.235), params.leanB_p_h - (params.b_l_t_r_pB / 12 * 0.1));
                model.lineTo(-(Temp_B_p_w / 2 + 0), params.leanB_p_h - (params.b_l_t_r_pB / 12 * 0.1));
                model.lineTo(-(Temp_B_p_w / 2 + 0), 0);
                model.closePath();
            } else {
                model.moveTo(-(Temp_B_p_w / 2 + 0.235), rightWallCloseSize + 0.1);
                model.lineTo(-(Temp_B_p_w / 2 + 0.235), 0);
                model.lineTo(-(Temp_B_p_w / 2 + 0), 0);
                model.lineTo(-(Temp_B_p_w / 2 + 0), rightWallCloseSize + 0.1);
                model.closePath();
            }
        }

        return model;
    }, [params.leanB_p_h, Temp_B_p_w, rightWallCloseSize, params.p_b_c_b_b_r, params.b_l_t_r_pB])

    const leftTrimObj = useMemo(() => {
        const trimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(frontLeftVrTrimModel, extrudeSettings(0.16)), new THREE.MeshStandardMaterial({color: 'red'}));
        const meshDoorDelModelLeft = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableBackLeanLeft', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'red' }));

        const frontTrimModel_Temp = trimModel.clone();
        frontTrimModel_Temp.position.set(0, 0, -0.07 - frontOffset - sidewallOffset);
        frontTrimModel_Temp.updateMatrixWorld();

        const backTrimModel_Temp = trimModel.clone();
        backTrimModel_Temp.position.set(0, 0, 0.02 + parseInt(params.add_storage_back) + sidewallOffset);
        backTrimModel_Temp.updateMatrixWorld();

        const doorDelModel_Temp = meshDoorDelModelLeft.clone();
        doorDelModel_Temp.position.set(params.leanB_p_w / 2 - 0.25, 0, params.backLeanStoragePosition + params.p_d / 2 + parseInt(params.add_storage_back));
        doorDelModel_Temp.rotation.y = Math.PI / 2;
        doorDelModel_Temp.updateMatrixWorld();

        const frontTrimModel_CSG = CSG.fromMesh(frontTrimModel_Temp);
        const backTrimModel_CSG = CSG.fromMesh(backTrimModel_Temp);
        const meshDoorDelModel_CSG = CSG.fromMesh(doorDelModel_Temp);

        const frontTrimModel_CSG_Temp = frontTrimModel_CSG.subtract(meshDoorDelModel_CSG);
        const backTrimModel_CSG_Temp = backTrimModel_CSG.subtract(meshDoorDelModel_CSG);

        const frontTrimModel = CSG.toMesh(frontTrimModel_CSG_Temp, new THREE.Matrix4()).geometry;
        const backTrimModel = CSG.toMesh(backTrimModel_CSG_Temp, new THREE.Matrix4()).geometry;

        return {frontTrimModel, backTrimModel}
    }, [frontLeftVrTrimModel, const_var.newDoorsArray, params.leanB_p_w, params.backLeanStoragePosition, params.add_storage_back])

    const rightTrimObj = useMemo(() => {
        const trimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(frontRightVrTrimModel, extrudeSettings(0.16)), new THREE.MeshStandardMaterial({color: 'red'}));
        const meshDoorDelModelRight = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableBackLeanRight', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'red' }));

        const frontTrimModel_Temp = trimModel.clone();
        frontTrimModel_Temp.position.set(0, 0, -0.07 - frontOffset - sidewallOffset);
        frontTrimModel_Temp.updateMatrixWorld();

        const backTrimModel_Temp = trimModel.clone();
        backTrimModel_Temp.position.set(0, 0, 0.02 + parseInt(params.add_storage_back) + sidewallOffset);
        backTrimModel_Temp.updateMatrixWorld();

        const doorDelModel_Temp = meshDoorDelModelRight.clone();
        doorDelModel_Temp.position.set( -params.leanB_p_w / 2 - 0.25, 0, params.backLeanStoragePosition + params.p_d / 2 + parseInt(params.add_storage_back));
        doorDelModel_Temp.rotation.y = Math.PI / 2;
        doorDelModel_Temp.updateMatrixWorld();

        const frontTrimModel_CSG = CSG.fromMesh(frontTrimModel_Temp);
        const backTrimModel_CSG = CSG.fromMesh(backTrimModel_Temp);
        const meshDoorDelModel_CSG = CSG.fromMesh(doorDelModel_Temp);

        const frontTrimModel_CSG_Temp = frontTrimModel_CSG.subtract(meshDoorDelModel_CSG);
        const backTrimModel_CSG_Temp = backTrimModel_CSG.subtract(meshDoorDelModel_CSG);

        const frontTrimModel = CSG.toMesh(frontTrimModel_CSG_Temp, new THREE.Matrix4()).geometry;
        const backTrimModel = CSG.toMesh(backTrimModel_CSG_Temp, new THREE.Matrix4()).geometry;

        return {frontTrimModel, backTrimModel}
    }, [frontRightVrTrimModel, const_var.newDoorsArray, params.leanB_p_w, params.backLeanStoragePosition, params.add_storage_back])
    
    const frontWallWainscotTrimObj = useMemo(() => {
        const meshWainscotTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(Temp_B_p_w + 0.02)), new THREE.MeshStandardMaterial({color: 'red'}))
        const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableBackLeanStorageFront', 'wall'), extrudeSettings(1)) , new THREE.MeshStandardMaterial({color: 'blue'}))
        const meshDoorDelModelLeft = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableBackLeanLeft', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'red' }));
        const meshDoorDelModelRight = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableBackLeanRight', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'red' }));

        const meshWainscotTrimModel_Temp = meshWainscotTrimModel.clone();
        meshWainscotTrimModel_Temp.position.set(-(Temp_B_p_w / 2 + 0.02), 3 , 0.01 - frontOffset - sidewallOffset);
        meshWainscotTrimModel_Temp.rotation.y = Math.PI/2;
        meshWainscotTrimModel_Temp.updateMatrixWorld();

        const meshDelModel_Temp = meshDelModel.clone();
        meshDelModel_Temp.position.set(-params.leanB_p_pos, 0, 0);
        meshDelModel_Temp.rotation.y = Math.PI;
        meshDelModel_Temp.updateMatrixWorld();

        let meshDoorDelModelLeft_Temp = meshDoorDelModelLeft.clone();
        meshDoorDelModelLeft_Temp.position.set(params.leanB_p_w / 2 - 0.25, 0, params.backLeanStoragePosition + params.p_d / 2 + parseInt(params.add_storage_back));
        meshDoorDelModelLeft_Temp.rotation.y = Math.PI / 2;
        meshDoorDelModelLeft_Temp.updateMatrixWorld();
    
        let meshDoorDelModelRight_Temp = meshDoorDelModelRight.clone();
        meshDoorDelModelRight_Temp.position.set( -params.leanB_p_w / 2 - 0.75, 0, params.backLeanStoragePosition + params.p_d / 2 + parseInt(params.add_storage_back));
        meshDoorDelModelRight_Temp.rotation.y = Math.PI / 2;
        meshDoorDelModelRight_Temp.updateMatrixWorld();

        const meshWainscotTrimModel_CSG = CSG.fromMesh(meshWainscotTrimModel_Temp);
        const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);
        const meshDoorDelModelLeft_CSG = CSG.fromMesh(meshDoorDelModelLeft_Temp);
        const meshDoorDelModelRight_CSG = CSG.fromMesh(meshDoorDelModelRight_Temp);

        const WainscotTrimModel_CSG = meshWainscotTrimModel_CSG.subtract(meshDelModel_CSG);
        const WainscotTrimModel_CSG_temp1 = WainscotTrimModel_CSG.subtract(meshDoorDelModelLeft_CSG);
        const WainscotTrimModel_CSG_temp2 = WainscotTrimModel_CSG_temp1.subtract(meshDoorDelModelRight_CSG);
        const CSGWainscotTrimModel = CSG.toMesh(WainscotTrimModel_CSG_temp2, new THREE.Matrix4());

        return CSGWainscotTrimModel.geometry;
    }, [Temp_B_p_w, params.leanB_p_pos, params.leanB_p_h, const_var.newDoorsArray, frontOffset, params.backLeanStoragePosition, params.add_storage_back])

    const backWallWainscotTrimObj = useMemo(() => {
        const meshWainscotTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(Temp_B_p_w + 0.3)), new THREE.MeshStandardMaterial({color: 'red'}))
        const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableBackLeanStorageBack', 'wall'), extrudeSettings(1)) , new THREE.MeshStandardMaterial({color: 'blue'}))
        const meshDoorDelModelLeft = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableBackLeanLeft', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'red' }));
        const meshDoorDelModelRight = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableBackLeanRight', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'red' }));

        const meshWainscotTrimModel_Temp = meshWainscotTrimModel.clone();
        meshWainscotTrimModel_Temp.position.set((Temp_B_p_w / 2 + 0.15), 3 , parseInt(params.add_storage_back) + 0.1 + sidewallOffset)
        meshWainscotTrimModel_Temp.rotation.y = -Math.PI/2
        meshWainscotTrimModel_Temp.updateMatrixWorld();

        const meshDelModel_Temp = meshDelModel.clone();
        meshDelModel_Temp.position.set( -params.leanB_p_pos, 0, parseInt(params.add_storage_back) - 0.5);
        meshDelModel_Temp.updateMatrixWorld();

        let meshDoorDelModelLeft_Temp = meshDoorDelModelLeft.clone();
        meshDoorDelModelLeft_Temp.position.set(params.leanB_p_w / 2 - 0.25, 0, params.backLeanStoragePosition + params.p_d / 2 + parseInt(params.add_storage_back));
        meshDoorDelModelLeft_Temp.rotation.y = Math.PI / 2;
        meshDoorDelModelLeft_Temp.updateMatrixWorld();
    
        let meshDoorDelModelRight_Temp = meshDoorDelModelRight.clone();
        meshDoorDelModelRight_Temp.position.set( -params.leanB_p_w / 2 - 0.75, 0, params.backLeanStoragePosition + params.p_d / 2 + parseInt(params.add_storage_back));
        meshDoorDelModelRight_Temp.rotation.y = Math.PI / 2;
        meshDoorDelModelRight_Temp.updateMatrixWorld();

        const meshWainscotTrimModel_CSG = CSG.fromMesh(meshWainscotTrimModel_Temp);
        const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);
        const meshDoorDelModelLeft_CSG = CSG.fromMesh(meshDoorDelModelLeft_Temp);
        const meshDoorDelModelRight_CSG = CSG.fromMesh(meshDoorDelModelRight_Temp);

        const WainscotTrimModel_CSG = meshWainscotTrimModel_CSG.subtract(meshDelModel_CSG);
        const WainscotTrimModel_CSG_temp1 = WainscotTrimModel_CSG.subtract(meshDoorDelModelLeft_CSG);
        const WainscotTrimModel_CSG_temp2 = WainscotTrimModel_CSG_temp1.subtract(meshDoorDelModelRight_CSG);
        const CSGWainscotTrimModel = CSG.toMesh(WainscotTrimModel_CSG_temp2, new THREE.Matrix4());

        return CSGWainscotTrimModel.geometry;
    }, [Temp_B_p_w, params.leanB_p_pos, params.leanB_p_h, const_var.newDoorsArray, params.add_storage_back, params.backLeanStoragePosition, params.add_storage_back])

    const rightWallWainscotTrimObj = useMemo(() => {
        const meshWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(parseInt(params.add_storage_back) + frontOffset + sidewallOffset * 2 - backOffset)))
        const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableBackLeanRight', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))

        let meshWainscotModel_Temp = meshWainscotModel.clone();
        meshWainscotModel_Temp.position.set(-(Temp_B_p_w / 2 + 0.155), 3 , 0.02 + parseInt(params.add_storage_back) + sidewallOffset - backOffset);
        meshWainscotModel_Temp.rotation.y = Math.PI;
        meshWainscotModel_Temp.updateMatrixWorld();

        let meshDelModel_Temp = meshDelModel.clone();
        meshDelModel_Temp.rotation.y = Math.PI / 2;
        meshDelModel_Temp.position.set(-Temp_B_p_w / 2 - 0.5, 0, params.p_d / 2 + parseInt(params.add_storage_back) + params.backLeanStoragePosition + 0.055);
        meshDelModel_Temp.updateMatrixWorld();
    
        const meshWainscotModel_CSG = CSG.fromMesh(meshWainscotModel_Temp);
        const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);

        const wainscotModel_CSG = meshWainscotModel_CSG.subtract(meshDelModel_CSG);

        const CSGWainscotModel = CSG.toMesh(wainscotModel_CSG,new THREE.Matrix4())

        return CSGWainscotModel.geometry;
    }, [params.leanB_p_d, Temp_B_p_w, params.p_w, rightWallCloseSize, const_var.newDoorsArray, params.leanB_p_pos, params.add_storage_back, frontOffset, params.backLeanStoragePosition])

    const leftWallWainscotTrimObj = useMemo(() => {
        const meshWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(parseInt(params.add_storage_back) + frontOffset + sidewallOffset * 2 - backOffset)))
        const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableBackLeanLeft', 'wall'), extrudeSettings(1)) , new THREE.MeshStandardMaterial({color: 'blue'}))

        let meshWainscotModel_Temp = meshWainscotModel.clone();
        meshWainscotModel_Temp.position.set((Temp_B_p_w / 2 + 0.155), 3 , 0.02 - frontOffset - sidewallOffset);
        meshWainscotModel_Temp.updateMatrixWorld();

        const meshDelModel_Temp = meshDelModel.clone();
        meshDelModel_Temp.rotateY(Math.PI / 2);
        meshDelModel_Temp.position.set((Temp_B_p_w / 2) - 0.5, 0, params.p_d / 2 + parseInt(params.add_storage_back) + params.backLeanStoragePosition + 0.05);
        meshDelModel_Temp.updateMatrixWorld();
    
        const meshWainscotModel_CSG = CSG.fromMesh(meshWainscotModel_Temp);
        const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);
    
        const wainscotModel_CSG = meshWainscotModel_CSG.subtract(meshDelModel_CSG);
        const CSGWainscotModel = CSG.toMesh(wainscotModel_CSG,new THREE.Matrix4())

        return CSGWainscotModel.geometry
    }, [params.leanB_p_d, Temp_B_p_w, params.p_w, const_var.newDoorsArray, leftWallCloseSize, params.leanB_p_pos, params.backLeanStoragePosition, params.add_storage_back, frontOffset])
    
    // --- right wall set    
    useMemo(() => {
        let tempWallCloseSize = 0;
        if (params.p_b_c_b_b_r === 'Open' || typeof(params.p_b_c_b_b_r) === 'object') {
            if (params.p_r_s === 1) {
                tempWallCloseSize = params.leanB_p_h - 0.25;
            } else {
                tempWallCloseSize = params.leanB_p_h;
            }
        } else if (params.p_b_c_b_b_r === "One_Fourth_Close") {
            tempWallCloseSize = params.leanB_p_h / 4 * 3;
        } else if (params.p_b_c_b_b_r === "Half_Close") {
            tempWallCloseSize = params.leanB_p_h / 2;
        } else if (params.p_b_c_b_b_r === "Three_Fourth_Close") {
            tempWallCloseSize = params.leanB_p_h / 4;
        } else if (params.p_b_c_b_b_r === "Close") {
            tempWallCloseSize = 0;
        } else {
            tempWallCloseSize = params.leanB_p_h - 3 * params.p_b_c_b_b_r;
        }

        setRightWallCloseSize(tempWallCloseSize);
        dispatch(setWallCloseStateWrap({'BLRightWallCloseState': tempWallCloseSize}))
    }, [params.p_b_c_b_b_r, params.leanB_p_h, params.p_r_s])

    // --- left wall close state    
    useMemo(() => {
        let tempWallCloseSize = 0;
        if (params.p_b_c_b_b_l === 'Open' || typeof(params.p_b_c_b_b_l) === 'object') {
            if (params.p_r_s === 1) {
                tempWallCloseSize = params.leanB_p_h - 0.25;
            } else {
                tempWallCloseSize = params.leanB_p_h;
            }
        } else if (params.p_b_c_b_b_l === "One_Fourth_Close") {
            tempWallCloseSize = params.leanB_p_h / 4 * 3;
        } else if (params.p_b_c_b_b_l === "Half_Close") {
            tempWallCloseSize = params.leanB_p_h / 2;
        } else if (params.p_b_c_b_b_l === "Three_Fourth_Close") {
            tempWallCloseSize = params.leanB_p_h / 4;
        } else if (params.p_b_c_b_b_l === "Close") {
            tempWallCloseSize = 0;
        } else {
            tempWallCloseSize = params.leanB_p_h - 3 * params.p_b_c_b_b_l;
        }

        setLeftWallCloseSize(tempWallCloseSize);
        dispatch(setWallCloseStateWrap({'BLLeftWallCloseState': tempWallCloseSize}))
    }, [params.p_b_c_b_b_l, params.leanB_p_h, params.p_r_s])

    return (
        <>
            <group position={[0, 0, -(params.p_d / 2 + parseInt(params.add_storage_back) + 0.05 + wallThickness)]}>
                {params.backLeanStoragePosition !== params.leanB_p_d - parseInt(params.add_storage_back) && <>
                    {params.p_b_c_b_b_l !== 'Close' && <mesh name="front-wall-left-trim" geometry={leftTrimObj.frontTrimModel}>
                        <MaterialTrim visibleSection={"gableBackLean"} />
                    </mesh>}
                    {params.p_b_c_b_b_r !== 'Close' && <mesh name="front-wall-right-trim" geometry={rightTrimObj.frontTrimModel}>
                        <MaterialTrim visibleSection={"gableBackLean"} />
                    </mesh>}
                    {params.p_w_c_n === true &&
                        <mesh name="G_B_L_S_F_W_wainscotTrim" geometry={frontWallWainscotTrimObj} >
                            <MaterialWainScotTrimNew visibleSection={"gableBackLean"}  />
                        </mesh>
                    }
                </>}
                {params.backLeanStoragePosition !== 0 && <>
                    {params.p_b_c_b_b_l !== 'Close' && <mesh name="back-wall-left-trim" geometry={leftTrimObj.backTrimModel}>
                        <MaterialTrim visibleSection={"gableBackLean"} />
                    </mesh>}
                    {params.p_b_c_b_b_r !== 'Close' && <mesh name="back-wall-right-trim" geometry={rightTrimObj.backTrimModel}>
                        <MaterialTrim visibleSection={"gableBackLean"} />
                    </mesh>}
                    {params.p_w_c_n === true && (cBBackWallCloseState > 3 || params.backLeanStoragePosition !== 0) && 
                        <mesh name="G_B_L_S_B_W_wainscotTrim" geometry={backWallWainscotTrimObj}>
                            <MaterialWainScotTrimNew visibleSection={"gableBackLean"}  />
                        </mesh>
                    }
                </>}
                {params.p_w_c_n === true &&
                    <mesh name="G_B_L_S_R_W_wainscotTrim" geometry={rightWallWainscotTrimObj} >
                        <MaterialWainScotTrimNew visibleSection={"gableBackLean"}  />
                    </mesh>
                }
                {params.p_w_c_n === true &&
                    <mesh name="G_B_L_S_L_W_wainscotTrim" geometry={leftWallWainscotTrimObj} >
                        <MaterialWainScotTrimNew visibleSection={"gableBackLean"}  />
                    </mesh>
                }
            </group>
        </>
    )
}

export default TrimModel